import axios from 'axios'
import React, { PureComponent } from 'react'

import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import CompletePayment from '../../components/organisms/CompletePayment/CompletePayment'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import './PaymentCompletePage.css'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'

class PaymentCompletePage extends PureComponent {
  async componentDidMount() {
    const url = new URL(window.location.href)
    const sessionId = url.searchParams.get('session_id')

    await axios.post('/api/v1/organizers/projects/checkout/complete', {
      session_id: sessionId
    })
  }

  render() {
    return (
      <div styleName="background">
        <div styleName="container">
          <div styleName="backgroudImage">
            <ImageAsset type={ImageAssetType.TOP_VISUAL} />
          </div>
          <div styleName="mainContent">
            <div styleName="titlePart">
              <div styleName="logo">
                <Logo type={LogoType.GRAY} />
              </div>
              <h1 styleName="title">お支払いが完了しました</h1>
            </div>
            <CompletePayment />
          </div>
        </div>
        <CommonFooter />
      </div>
    )
  }
}

export default PaymentCompletePage
